/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { FancyAction } from '../base/FancyAction';
import { FancyFirebaseList } from '../base/FancyFirebaseList';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

export interface UserIndex {
	projectId: string;
	projectMemberId: string;
}

export class UserIndexList extends FancyFirebaseList<UserIndex, FancyAction> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		return {
			projectId: action.key,
			projectMemberId: action.payload.child('projectMemberId').val(),
		};
		// return new SimpleFirebaseModel<UserIndex>(action.key, action.payload.val());
	}
	public $$updated(child: UserIndex, action: AngularFireAction<DatabaseSnapshot<any>>) {
		child.projectMemberId = action.payload.child('projectMemberId').val();
	}
}
